module.exports = __webpack_public_path__ + "img/80s-night.fd65432e.jpeg";